import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconLockSharpLine = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 25 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.013 2.999a5 5 0 0 0-5 5v1h-3v12h16V9h-3V8a5 5 0 0 0-5-5Zm3 6V8a3 3 0 0 0-6 0v1h6Zm-9 2v8h12v-8h-12Zm6.768 4.17c.313-.232.515-.6.515-1.016 0-.7-.574-1.267-1.283-1.267-.708 0-1.283.568-1.283 1.267 0 .426.213.803.54 1.033l-.208 2.023h1.902l-.183-2.04Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconLockSharpLine);
export default Memo;
